module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE WAS IN THE")]), _vm._v(" bedroom, absently packing a suitcase, when his son came home to the new seaside condo they shared in the Malibu Sector. It was late afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He heard something fall over and something smash. Calling, “Dan, what’s happening?” he ran down the hall to the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dan, a lanky young man of fifteen, was standing in the center of the bright room. He was scowling down at a small tipped over plastable and the broken voxclock lying sprawled beside it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hi, Dad.” He came over to hug Jake.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake returned the hug. “So?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I kicked over the table.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Any particular reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I was pissed off about something.” He dropped his school gear on the low white sofa. “Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Something I ought to know about?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not really, no.” Dan unfastened his SoCal State Police Academy tunic, slipped out of it and tossed it in the direction of the sofa. “I didn’t expect you to be home this early.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You wouldn’t have booted the furniture if you’d known I was around, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Probably not, nope.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake put a hand on his son’s shoulder. “C’mon—what’s wrong, Dan?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Moving away from him, Dan bent and righted the table. “It was just a thing that happened in one of my classes at the academy today,” he said. “I ... well, I suppose you’ll hear about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’ll spoil the surprise,” said Jake, sitting on the sofa, “but you might as well fill me in now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dan gathered up the clock, depositing the remains on the uprighted table. “Do you know an asshole named Dick Farber?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sure, we were SoCal State cops together. Back when,” he answered. “Dick and I, though, were never what you’d call close friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I deduced as much,” said his son. “Farber was a guest lecturer in our Interrogation Procedures class this afternoon. When the TA-bot gave him the roster and he saw my name, he wanted to know if I was related to you. I said you were my father and ... Well, he made some remarks.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“About my having spent time as a prisoner up in the Freezer?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That was one of the topics. Farber thinks you were guilty of Tek dealing.” Dan’s hands fisted at his sides. “He hinted, you know, that if it hadn’t been for the influence of corrupt people like Bascom you’d still be on ice up there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Even though I was cleared of all those charges after I got out, you’re still going to run into people who’ll tell you I was really guilty,” he told his son. “Farber’s one of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I know,” said Dan. “You warned me when I first told you I wanted to go into police work, that there’d be cops who don’t think much of you. And, since they didn’t care for you, they probably weren’t going to be too nice to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Looks like that’s turning out to be so. Why is the academy going to contact me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh, because they have a halfassed rule about cadets punching teachers. Even guest lecturers.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake grinned. “You hit Farber?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dan poked at his own midsection. “Right here. Twice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Getting up, Jake said, “Okay, I’ll have a talk with a couple of the people I know at the academy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You don’t have to fight my battles. I just wanted you to know what—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Farber was out of line, too, Dan. I’ll get this straightened out. Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sure, okay. Thanks, Dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“This probably won’t affect your standing at school. But, hey, don’t slug any more of my former colleagues.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Try not to. But that asshole made me mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I understand.” Jake moved toward the hall. “I’ll be leaving in about an hour. Going up to Berkeley to see Beth.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Has something happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not to Beth, but Gomez and I have to leave for Rio de Janeiro early tomorrow. I want to see Beth, spend some time with her, before I go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Rio?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake outlined the new Cosmos assignment to his son, explaining why he felt obliged to go down there to Brazil.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When he finished, Dan told him, “I can see why you feel you have to do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah, except this isn’t the right time.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“If I know you, you’ll find this Sparey quickly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Maybe,” said Jake. “The thing is—Oh, hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nothing.” Jake shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, you look like something’s worrying you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Only a feeling,” said Jake. “A feeling that I should stay with Beth and not let her out of my sight.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-015858e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/7-chap4.vue
// module id = 81
// module chunks = 0